import { ProviderContext } from 'notistack';
import React from 'react';

import { Toast } from 'src/components/Toast';
import { getElectronAPI } from 'src/hooks/useElectron';

export const useElectronUpdates = (
  enqueueSnackbar: ProviderContext['enqueueSnackbar'],
) => {
  React.useEffect(() => {
    const api = getElectronAPI();
    if (!api) return;

    const unsub = api.onUpdateDownloaded((info: unknown) => {
      const version = (info as { version?: string })?.version;
      enqueueSnackbar('Update ready', {
        persist: true,
        content: (key: string) => (
          <div key={key}>
            <Toast
              variant="info"
              title={`Version ${version ?? 'unknown'} is ready`}
              description="Restart to update Assembly"
              actionProps={{
                onClick: () => api.installUpdate(),
                children: 'Restart now',
                className: 'text-base',
              }}
            />
          </div>
        ),
      });
    });

    return unsub;
  }, [enqueueSnackbar]);
};
